// import React from "react";
import "./DynaInput.scss";

const DynaInputKeyword = (props) => {
  return (
    <div
      className={`label-input-dyna keyword ${
        props.className !== undefined ? props.className : ""
      }`}
    >
      <label htmlFor={props.name}>{props.label}</label>
      <div className="inputAndKeywordContainer">
        <input
          id={props.id}
          className={`dyna-element ${
            props.classNameInput !== undefined ? props.classNameInput : ""
          }`}
          name={props.name}
          type={props.type}
          placeholder={props.placeholder}
          value={props.value}
          style={props.style}
          disabled={props.disabled}
          onChange={props.onChange}
          onKeyUp={props.onKeyUp}
        />
        <span className="keyword">{props.keyword}</span>
      </div>
    </div>
  );
};
export default DynaInputKeyword;
